var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCirclePlusPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.583008 7.00127C0.583008 3.45666 3.45561 0.583626 6.99967 0.583626C10.5438 0.583626 13.4163 3.45666 13.4163 7.00127C13.4163 10.5452 10.5438 13.4189 6.99967 13.4189C3.45558 13.4189 0.583008 10.5452 0.583008 7.00127Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50475 4.77395C7.50475 4.49414 7.27794 4.2673 6.99817 4.2673C6.71841 4.2673 6.4916 4.49414 6.4916 4.77395V6.49528H4.76927C4.4895 6.49528 4.2627 6.72206 4.2627 7.00194C4.2627 7.28175 4.4895 7.5086 4.76927 7.5086H6.4916V9.22771C6.4916 9.50752 6.71841 9.73437 6.99817 9.73437C7.27794 9.73437 7.50475 9.50752 7.50475 9.22771V7.5086H9.22692C9.50675 7.5086 9.7335 7.28175 9.7335 7.00194C9.7335 6.72206 9.50675 6.49528 9.22692 6.49528H7.50475V4.77395Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCirclePlusPrimary);
export default __webpack_public_path__ + "static/media/ic_circle_plus_primary.65efa93554d1c9f291ec534957a40e1c.svg";
export { ForwardRef as ReactComponent };